import { addMonetaryValues, getZeroMonetaryValue } from '../../../../utils/monetary-value-utils';
import { calculateBookingFeeForShowtime } from '../../utils/order-showtime-utils';
import { getOrderShowtimes } from '../showtimes/get-order-showtimes';
import { isBookingFeeApplicableToOrder } from './is-booking-fee-applicable-to-order';
export const getOrderBookingFee = () => {
    if (!isBookingFeeApplicableToOrder())
        return getZeroMonetaryValue();
    return addMonetaryValues(...getOrderShowtimes().map(showtime => calculateBookingFeeForShowtime(showtime)));
};
